module.exports = function() {
  return new Worker(__webpack_public_path__ + "75838f7f3142456260a4.worker.js");
};